var _process$env$REACT_AP;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o);
}
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r)
    i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;
else {
    var o = function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); };
    o("next", 0), o("throw", 1), o("return", 2);
} }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t)
    return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
        return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return ("string" === r ? String : Number)(t); }
import { Box, Container, CssBaseline, Toolbar, Typography, AppBar as MuiAppBar, Chip } from '@mui/material';
import { styled, useTheme } from '@mui/material/styles';
import React, { useEffect, useState } from 'react';
import { constants } from '../constants';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfigContext } from './ConfigContext';
import LogoutModal from './LogoutModal';
import { LogoAndProductName } from './LogoAndProductName';
import { SettingsAPI } from '../apis';
import { SidebarMenu } from '@deloitte/cc-ui-library';
import { HomeOutlined, DiamondOutlined, CategoryOutlined, DeviceHubOutlined, DashboardOutlined } from '@mui/icons-material';
var drawerWidth = 240;
var AppBar = styled(MuiAppBar, {
    shouldForwardProp: function shouldForwardProp(prop) {
        return prop !== 'open';
    }
})(function (_ref) {
    var theme = _ref.theme, open = _ref.open;
    return _objectSpread({
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen
        })
    }, open && {
        marginLeft: drawerWidth,
        width: "calc(100% - ".concat(drawerWidth, "px)"),
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen
        })
    });
});
var applicationIcons = [HomeOutlined, DiamondOutlined, CategoryOutlined, DeviceHubOutlined, DashboardOutlined];
var defaultItems = ((_process$env$REACT_AP = process.env.REACT_APP_PRODUCTS) === null || _process$env$REACT_AP === void 0 ? void 0 : _process$env$REACT_AP.split(',').map(function (product, index) {
    var _process$env$REACT_AP2, _process$env$REACT_AP3;
    return {
        isLink: true,
        text: (_process$env$REACT_AP2 = (_process$env$REACT_AP3 = process.env.REACT_APP_NAME) === null || _process$env$REACT_AP3 === void 0 ? void 0 : _process$env$REACT_AP3.split(',')[index]) !== null && _process$env$REACT_AP2 !== void 0 ? _process$env$REACT_AP2 : '',
        url: "/".concat(product),
        icon: applicationIcons[index] || DashboardOutlined,
        isDefaultActiveLink: index == 0 ? true : false
    };
})) || [];
export default function MiniDrawer(_ref2) {
    var _defaultItems$find, _process$env$REACT_AP4, _process$env$REACT_AP5, _configState$settings;
    var children = _ref2.children;
    var theme = useTheme();
    var _React$useContext = React.useContext(ConfigContext), configState = _React$useContext.configState, setConfigState = _React$useContext.setConfigState;
    var _useState = useState(configState.selectedProduct), _useState2 = _slicedToArray(_useState, 2), application = _useState2[0], setApplication = _useState2[1];
    var navigate = useNavigate();
    var _useState3 = useState(false), _useState4 = _slicedToArray(_useState3, 2), isScrolledToBottom = _useState4[0], setIsScrolledToBottom = _useState4[1];
    var _useState5 = useState(''), _useState6 = _slicedToArray(_useState5, 2), userRole = _useState6[0], setUserRole = _useState6[1];
    var _useState7 = useState(true), _useState8 = _slicedToArray(_useState7, 2), isOpen = _useState8[0], setIsOpen = _useState8[1];
    var _useLocation = useLocation(), pathname = _useLocation.pathname;
    var _useState9 = useState(((_defaultItems$find = defaultItems.find(function (item) {
        return pathname.includes(item.url);
    })) === null || _defaultItems$find === void 0 ? void 0 : _defaultItems$find.text) || ''), _useState0 = _slicedToArray(_useState9, 2), selectedItem = _useState0[0], setSelectedItem = _useState0[1];
    var _useState1 = useState(true), _useState10 = _slicedToArray(_useState1, 2), isLoading = _useState10[0], setIsLoading = _useState10[1];
    var showSideBar = ((_process$env$REACT_AP4 = process.env.REACT_APP_PRODUCTS) !== null && _process$env$REACT_AP4 !== void 0 ? _process$env$REACT_AP4 : '').split(',').length > 1 && pathname != '/settings' && pathname != '/userManagement' && JSON.parse((_process$env$REACT_AP5 = process.env.REACT_APP_false) !== null && _process$env$REACT_AP5 !== void 0 ? _process$env$REACT_AP5 : '"false"');
    // Update selectedItem when pathname changes
    useEffect(function () {
        var _defaultItems$find2;
        var newSelectedItem = ((_defaultItems$find2 = defaultItems.find(function (item) {
            return pathname.includes(item.url);
        })) === null || _defaultItems$find2 === void 0 ? void 0 : _defaultItems$find2.text) || '';
        setSelectedItem(newSelectedItem);
    }, [pathname]);
    var handleClickItem = function handleClickItem(url) {
        var _defaultItems$find3;
        var selectedItemText = (_defaultItems$find3 = defaultItems.find(function (item) {
            return item.url === url;
        })) === null || _defaultItems$find3 === void 0 ? void 0 : _defaultItems$find3.text;
        if (selectedItemText) {
            setSelectedItem(selectedItemText);
        }
        navigate({
            pathname: url
        });
    };
    useEffect(function () {
        var _sessionStorage$getIt, _roleObject$;
        var roleObject = typeof window !== 'undefined' ? JSON.parse((_sessionStorage$getIt = sessionStorage.getItem('policy')) !== null && _sessionStorage$getIt !== void 0 ? _sessionStorage$getIt : '{}') : undefined;
        var userRole = roleObject ? (_roleObject$ = roleObject[0]) === null || _roleObject$ === void 0 ? void 0 : _roleObject$.name : null;
        setUserRole(userRole);
        setApplication(configState.selectedProduct);
    }, []);
    useEffect(function () {
        var fetchData = /*#__PURE__*/ function () {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
                return _regenerator().w(function (_context) {
                    while (1)
                        switch (_context.n) {
                            case 0:
                                _context.n = 1;
                                return Promise.all([getSettings(), getPageImage(), getHeaderImage()]);
                            case 1:
                                setIsLoading(false); // Set loading to false after all API calls are complete
                            case 2:
                                return _context.a(2);
                        }
                }, _callee);
            }));
            return function fetchData() {
                return _ref3.apply(this, arguments);
            };
        }();
        fetchData();
    }, []);
    var getSettings = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2() {
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.n) {
                        case 0:
                            _context2.n = 1;
                            return SettingsAPI.getSettings().then(function (response) {
                                setConfigState(function (prevState) {
                                    return _objectSpread(_objectSpread({}, prevState), {}, {
                                        settings: _objectSpread(_objectSpread({}, prevState.settings), response)
                                    });
                                });
                            });
                        case 1:
                            return _context2.a(2);
                    }
            }, _callee2);
        }));
        return function getSettings() {
            return _ref4.apply(this, arguments);
        };
    }();
    var getPageImage = /*#__PURE__*/ function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.n) {
                        case 0:
                            _context3.n = 1;
                            return SettingsAPI.getSettingsImage('theme', 'image').then(function (response) {
                                setConfigState(function (prevState) {
                                    return _objectSpread(_objectSpread({}, prevState), {}, {
                                        settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                            page_image: response
                                        })
                                    });
                                });
                            });
                        case 1:
                            return _context3.a(2);
                    }
            }, _callee3);
        }));
        return function getPageImage() {
            return _ref5.apply(this, arguments);
        };
    }();
    var getHeaderImage = /*#__PURE__*/ function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.n) {
                        case 0:
                            _context4.n = 1;
                            return SettingsAPI.getSettingsImage('theme', 'logo').then(function (response) {
                                setConfigState(function (prevState) {
                                    return _objectSpread(_objectSpread({}, prevState), {}, {
                                        settings: _objectSpread(_objectSpread({}, prevState.settings), {}, {
                                            header_logo_image: response
                                        })
                                    });
                                });
                            });
                        case 1:
                            return _context4.a(2);
                    }
            }, _callee4);
        }));
        return function getHeaderImage() {
            return _ref6.apply(this, arguments);
        };
    }();
    useEffect(function () {
        if (configState.selectedProduct != '')
            setApplication(configState.selectedProduct);
        else {
            var _process$env$REACT_AP6;
            setApplication(((_process$env$REACT_AP6 = process.env.REACT_APP_PRODUCTS) !== null && _process$env$REACT_AP6 !== void 0 ? _process$env$REACT_AP6 : '').split(',')[0]);
        }
    }, [configState.selectedProduct]);
    useEffect(function () {
        var handleScroll = function handleScroll() {
            var windowHeight = window.innerHeight;
            var documentHeight = document.documentElement.scrollHeight;
            var scrollTop = window.scrollY;
            var bottomThreshold = 20;
            var isAtBottom = scrollTop + windowHeight >= documentHeight - bottomThreshold;
            setIsScrolledToBottom(isAtBottom);
        };
        var resizeObserver = new ResizeObserver(function (entry) {
            if (entry != null) {
                handleScroll();
            }
        });
        window.addEventListener('scroll', handleScroll);
        // Checks the div the holds the entire page for resizing
        // Prevents elements from overlapping with the footer if they expand down
        var rootElement = document.getElementById('root');
        if (rootElement) {
            resizeObserver.observe(rootElement);
        }
        return function () {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);
    return /*#__PURE__*/ React.createElement(Box, null, /*#__PURE__*/ React.createElement(CssBaseline, null), !isLoading && pathname != '/' && application != '' ?
        /*#__PURE__*/
        // Render only when loading is complete
        React.createElement(AppBar, {
            position: "fixed",
            sx: {
                background: "".concat(configState === null || configState === void 0 || (_configState$settings = configState.settings) === null || _configState$settings === void 0 ? void 0 : _configState$settings.header_background_color),
                borderBottom: '1px solid #EBEBEB',
                zIndex: 1200,
                boxShadow: 'none',
                height: 60
            }
        }, /*#__PURE__*/ React.createElement(Toolbar, {
            sx: {
                padding: '20px !important',
                minHeight: '60px !important'
            }
        }, /*#__PURE__*/ React.createElement(LogoAndProductName, {
            pathname: pathname,
            application: selectedItem
        }), application === 'associateProductivity' && /*#__PURE__*/ React.createElement(Chip, {
            label: userRole,
            sx: {
                backgroundColor: '#37474f',
                marginRight: '16px',
                color: '#ffffff',
                fontFamily: 'Open Sans',
                fontSize: '13px',
                fontWeight: '400',
                height: '24px'
            }
        }), application === 'inventory' && /*#__PURE__*/ React.createElement(Chip, {
            label: "Inventory Manager",
            sx: {
                backgroundColor: '#fff',
                border: '1px solid #d9d9d9',
                marginRight: '12px',
                color: '#000',
                fontFamily: 'Open Sans',
                fontSize: '12px',
                fontWeight: '600',
                height: '24px'
            }
        }), /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex'
            }
        }, /*#__PURE__*/ React.createElement(LogoutModal, null)))) : null, !isLoading && /*#__PURE__*/ React.createElement(React.Fragment, null, showSideBar && /*#__PURE__*/ React.createElement(SidebarMenu, {
        isOpen: isOpen,
        setIsOpen: setIsOpen,
        onClickItem: handleClickItem,
        selectedItem: selectedItem,
        navItems: defaultItems,
        topSpacing: 60
    }), /*#__PURE__*/ React.createElement(Box, {
        component: "main",
        sx: {
            flexGrow: 1,
            pb: 0,
            position: 'relative',
            top: 60,
            marginLeft: showSideBar ? isOpen ? '240px' : '56px' : 0,
            width: showSideBar ? "calc(100% - ".concat(isOpen ? 240 : 56, "px)") : '100%',
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            })
        }
    }, !isLoading && /*#__PURE__*/ React.createElement(Container, {
        maxWidth: false,
        disableGutters: true,
        sx: {
            backgroundColor: theme.palette.background["default"],
            marginBottom: '55px'
        },
        role: "container-parent"
    }, children), !isLoading && isScrolledToBottom && /*#__PURE__*/ React.createElement(Box, {
        component: "footer",
        sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            backgroundColor: '#F8F8F8',
            left: showSideBar ? isOpen ? '240px' : '56px' : 0,
            transition: theme.transitions.create(['left'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen
            }),
            position: 'fixed',
            bottom: 0,
            right: 0,
            padding: '16px',
            zIndex: 1000
        }
    }, /*#__PURE__*/ React.createElement(Typography, null, constants.Copyright_text1 + new Date().getFullYear() + constants.Copyright_text2), "\xA0\xA0\xA0\xA0", /*#__PURE__*/ React.createElement("a", {
        href: process.env.REACT_APP_https://resources.deloitte.com/sites/US/system/Pages/DeloitteNet_Web_Privacy_statement.aspx,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            textDecoration: 'none',
            color: 'inherit'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    }, constants.privacy)), "\xA0\xA0\xA0\xA0", /*#__PURE__*/ React.createElement("a", {
        href: "/terms-of-use",
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
            textDecoration: 'none',
            color: 'inherit'
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    }, constants.terms_of_use))))));
}
